import { render, staticRenderFns } from "./VehicleRemindersPage.vue?vue&type=template&id=20f43385&"
import script from "./VehicleRemindersPage.vue?vue&type=script&lang=js&"
export * from "./VehicleRemindersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports